import { CrudPage } from "../components/CrudPage";
import { useLang } from "../lib/i18n";
import { PhoneLink } from "../lib/format";

export default function Customers() {
  const { t } = useLang();
  return (
    <CrudPage
      title={t("nav_customers")}
      endpoint="customers"
      testPrefix="customers"
      columns={[
        { key: "name", label: t("name") },
        { key: "phone", label: "Telepon", render: (c) => <PhoneLink phone={c.phone} /> },
        { key: "email", label: t("email") },
        { key: "address", label: "Alamat" },
      ]}
      fields={[
        { name: "name", label: t("name") },
        { name: "phone", label: "Telepon" },
        { name: "email", label: t("email") },
        { name: "address", label: "Alamat", type: "textarea" },
      ]}
    />
  );
}
